import { getDatabase, ref, runTransaction } from 'firebase/database';
import { getParticipantGroupSessionPath } from './firebasePaths';

const extendSessionTransaction = (totalExtendedDuration: number) => (data) => {
    if(data === null) {
        return { totalExtendedDuration: totalExtendedDuration };
    }
    const oldDuration = data.totalExtendedDuration || 0;
    return { totalExtendedDuration: oldDuration + totalExtendedDuration };
};

export const extendSessionInFirebase = async (
    totalExtendedDuration: number,
    sessionId: string,
    participantGroupId?: string | number,
): Promise<boolean> => {
    const database = getDatabase();
    const sessionRef = ref(database, `session_v2/${sessionId}/extend`);
    const transactions = [runTransaction(sessionRef, extendSessionTransaction(totalExtendedDuration))];
    if (participantGroupId !== undefined && participantGroupId !== null) {
        const groupSessionExtendRef = ref(
            database,
            `${getParticipantGroupSessionPath(participantGroupId, sessionId)}/extend`,
        );
        transactions.push(
            runTransaction(groupSessionExtendRef, extendSessionTransaction(totalExtendedDuration)),
        );
    }
    return Promise.all(transactions)
    .then(() => {
        return true;
    })
    .catch((error) => {
        console.error("Error extending session: ", error);
        return false;
    });
};
